import {useMutation} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type DeleteMilestoneInput = {
  number: number
  nameWithOwner: string
}

async function deleteMilestone({number, nameWithOwner}: DeleteMilestoneInput): Promise<void> {
  let response: Response
  try {
    response = await reactFetchJSON(`/${nameWithOwner}/milestones/${number}`, {
      method: 'DELETE',
    })
  } catch {
    throw new Error('Could not delete Milestone')
  }

  if (!response.ok) {
    throw new Error('Could not delete Milestone')
  }

  if (response.status !== 204) {
    const result = await response.json()
    if (result.error) {
      throw new Error('Could not delete Milestone')
    }
  }
}

export function useDeleteMilestoneMutation({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void
  onError?: (error: Error) => void
} = {}) {
  return useMutation<void, Error, DeleteMilestoneInput>({
    mutationFn: deleteMilestone,
    onSuccess,
    onError,
  })
}
